module.exports = __webpack_public_path__ + "images/add_to_friends_v2.b4bba977.gif";